import { render, staticRenderFns } from "./section-container.vue?vue&type=template&id=60cdf6be&scoped=true&"
import script from "./section-container.vue?vue&type=script&lang=js&"
export * from "./section-container.vue?vue&type=script&lang=js&"
import style0 from "./section-container.vue?vue&type=style&index=0&id=60cdf6be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdf6be",
  null
  
)

export default component.exports